import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import { Topbar } from '@/modules/core/components';
import ContributionActivitiesList from '@/modules/employer/components/ContributionActivities/ContributionActivitiesList';
import { useGetContributionRequestRecords } from '@/modules/employer/components/ContributionActivities/queries/useGetContributionRequestRecords.query';
import { useEditModeWidth } from '@/modules/employer/components/ContributionActivities/useEditModeWidth';
import {
  ContributionListItemType,
  ContributionRequestStatus,
} from '@/modules/employer/components/Contributions/contributions.types';

import PageScrollVisibleWrapper from './PageScrollVisibleWrapper';

export const goToContributionActivities = (contribution?: ContributionListItemType) =>
  window.open(
    `${ROUTES.CONTRIBUTION_ACTIVITIES(contribution?.contributionId)}${window.location.search}${window.location.hash}`,
    '_blank'
  );

const ContributionActivitiesPage = () => {
  const { contributionId } = useParams<{ contributionId: string }>();
  const { contributionRequest } = useGetContributionRequestRecords(contributionId);
  const [submitDate, isApprovalNeededStatus] = useMemo(
    () => [
      contributionRequest?.submitDate || '',
      contributionRequest?.status === ContributionRequestStatus.APPROVAL_NEEDED,
    ],
    [contributionRequest]
  );
  const { width } = useEditModeWidth();

  return (
    <PageScrollVisibleWrapper>
      <Topbar />
      <Box align="center" pad={{ bottom: 'spacing72' }}>
        <Box width={width}>
          {submitDate ? (
            <ContributionActivitiesList
              contributionId={contributionId}
              isApprovalNeededStatus={isApprovalNeededStatus}
              submitDate={submitDate}
            />
          ) : null}
        </Box>
      </Box>
    </PageScrollVisibleWrapper>
  );
};

export default ContributionActivitiesPage;
